'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/feature-link.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _icon = require('@marmalade/icon');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Icon = (0, _icon.primaryIconComponent)('3rem');
var FeatureLink = function (_Component) {
  _inherits(FeatureLink, _Component);
  function FeatureLink() {
    _classCallCheck(this, FeatureLink);
    return _possibleConstructorReturn(this, (FeatureLink.__proto__ || Object.getPrototypeOf(FeatureLink)).apply(this, arguments));
  }
  _createClass(FeatureLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        theme = _props.theme,
        title = _props.title,
        href = _props.href,
        imgSrc = _props.imgSrc,
        iconType = _props.iconType,
        alt = _props.alt,
        css = _props.css,
        imgCss = _props.imgCss,
        rest = _objectWithoutProperties(_props, ['theme', 'title', 'href', 'imgSrc', 'iconType', 'alt', 'css', 'imgCss']);
      return _react2.default.createElement(_glamorous2.default.A, Object.assign({
        href: href,
        css: Object.assign({}, css)
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 30
        },
        __self: this
      }), iconType && _react2.default.createElement(Icon, {
        type: iconType,
        css: {
          marginRight: theme.space_xs
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37
        },
        __self: this
      }), _react2.default.createElement(_glamorous2.default.P, {
        css: {
          verticalAlign: 'middle',
          display: 'inline-block'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 38
        },
        __self: this
      }, title), _react2.default.createElement(_glamorous2.default.Img, {
        src: imgSrc,
        alt: alt,
        title: title,
        css: Object.assign({
          display: 'block'
        }, imgCss),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 39
        },
        __self: this
      }));
    }
  }]);
  return FeatureLink;
}(_react.Component);
FeatureLink.propTypes = {
  title: _propTypes.string.isRequired,
  href: _propTypes.string.isRequired,
  imgSrc: _propTypes.string.isRequired,
  alt: _propTypes.string.isRequired,
  theme: _propTypes.object.isRequired,
  css: _propTypes.object,
  imgCss: _propTypes.object,
  iconType: _propTypes.string
};
FeatureLink.defaultProps = {
  css: undefined,
  imgCss: undefined,
  iconType: undefined
};
exports.default = (0, _glamorous.withTheme)(FeatureLink);